import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ slug: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.slug, form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <canvas id="login-canvas" className="login-canvas"></canvas>

      <div className="login-card">
        <div className="login-brand">
          <div className="login-brand-dot"></div>
          <span className="login-brand-name">TRACE</span>
        </div>
        <div className="login-tagline">We Track. You Improve.</div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label>Shop ID</label>
            <input
              name="slug"
              placeholder="e.g. ct-paper"
              value={form.slug}
              onChange={handleChange}
              required
              autoFocus
              autoComplete="off"
            />
          </div>
          <div className="login-field">
            <label>Email</label>
            <input
              name="email"
              type="email"
              placeholder="you@yourshop.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="login-field">
            <label>Password</label>
            <input
              name="password"
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In →'}
          </button>
        </form>

        <div className="login-footer">
          <span>Don't have an account?</span>
          <Link to="/register" className="login-register-link">Register your shop</Link>
        </div>

        <a href="https://traceoperations.com" className="login-back">
          ← Back to traceoperations.com
        </a>
      </div>
    </div>
  );
}